import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import ErrorOutline from 'material-ui/svg-icons/alert/error-outline';
import Done from 'material-ui/svg-icons/action/done';
import StripeCheckout from './StripeCheckout';
import CircularProgress from 'material-ui/CircularProgress';
import { Card, CardHeader, CardText } from 'material-ui/Card';

import countries from '../modules/countries';

import { getPlan, validateEmail, registerSingleFreeUser } from '../actions/actions';

import apiErrors from '../modules/apierrors';
import getErrors from '../modules/geterrors';

import './SingleUserRegistration.css';


// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

class SingleUserRegistrationAndroid extends Component {
  constructor() {
    super();

    this.state = {
      form: {
        name: '',
        email: {
          value: '',
          error: '',
        },
        password: '',
        countryCode: null,
        remember: true,
      },
    };
  }

  componentWillMount() {
    this.props.dispatch(getPlan());
  }

  validateForm = () => {
    const creds = {
      email: this.state.form.email.value,
      password: this.state.form.password
    };

    this.props.dispatch(registerSingleFreeUser(creds));
  }

  handleForm = (event) => {
    event.preventDefault();

    const form = { ...this.state.form };

    form.email.value = this.emailInput.getValue();
    form.password = this.pwInput.getValue();

    const validEmail = form.email.value.match(emailRegexp);

    if (validEmail) {
      this.props.dispatch(validateEmail({ email: form.email.value }));
    }

    this.setState({ form });
  }

  renderAccountForm = () => {
    const email = this.props.validation.email;
    const singleRegistration = this.props.singleregistration;

    const disabled = this.state.form.password.length < 6
                          || !email.hasFetched
                          || !email.isValid
                          || singleRegistration.isFetching
                          || singleRegistration.isRegistered;

    //const { errorMessages, validationErrors } = getErrors(email.errors);
    const { errorMessages, validationErrors } = getErrors(singleRegistration.errors);

    const emailErrorMessage = apiErrors[validationErrors.email] || validationErrors.email;
    const passwordErrorMessage = apiErrors[validationErrors.password] || validationErrors.password;

    let emailError;

    if (this.state.form.email.value.length > 5 && !this.state.form.email.value.match(emailRegexp)) {
      emailError = 'This is not a valid email address';
    }

    if (email.hasFetched && !email.isValid) {
      emailError = 'This address is already in use';
    }

    let validating = '';

    let success = '';

    if (singleRegistration.isRegistered) {
      success = <span><Done style={{ width: '128px', height: '128px'}} color="green" /><br /><p style={{marginBottom: 0}}>OK! Now, just install the app:</p>
              <a target="_blank" rel="noopener" href='https://play.google.com/store/apps/details?id=com.sanako.pronounce_live&utm_source=frontpage&utm_campaign=android-beta&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img width="160" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'/></a>
              <p style={{fontSize: '14px'}}>(Or <a href="http://www.pronouncelive.com/">login to the web version here</a>)</p>
            </span>;
    }

    const label = singleRegistration.isFetching ? <CircularProgress size={20} /> : "Let's Go";

    const title = disabled ? 'Please fill out all the fields to activate this button': 'This will create your account and start your trial';

    const btnStyle = {
      color: '#fff'
    }

    let subscriptionInfo = '';

    const symbols = {
      EUR: '€',
      USD: '$',
      GBP: '£'
    };

    if (this.props.subscriptions.hasFetchedPlan) {
      const price = this.props.subscriptions.plan.price / 100;
      const curSymbol = symbols[this.props.subscriptions.plan.currency];
      subscriptionInfo = `Subscription available for 6 months / ${price} ${curSymbol}`;
    }

    return (
      <Card>
      <div className="account-form">
        <TextField
          autoFocus={true}
          onChange={this.handleForm}
          ref={(input) => { this.emailInput = input; }}
          errorText={emailErrorMessage || emailError}
          floatingLabelText="Email"
          type="email"
          name="email"
          value={this.state.form.email.value}
        />
        {validating}
        <br />

        <TextField
          errorText={passwordErrorMessage}
          onChange={this.handleForm}
          ref={(input) => { this.pwInput = input; }}
          type="password"
          name="password"
          floatingLabelText="Password"
          hintText="At least 6 characters"
          value={this.state.form.password}
        /><br />
      <br /><br />
        <RaisedButton
          id="create-account"
          backgroundColor="#31C04C"
          disabledBackgroundColor="rgb(203, 239, 210)"
          style={btnStyle}
          disabled={disabled}
          onTouchTap={this.validateForm}
          label={label}
          title={title}
          primary
        />
      <p className="details">By creating this account you agree to our <a target="_blank" href="/terms" title="The terms will open in a new window">Terms of Use</a> and <a target="_blank" href="/privacy" title="The privacy policy will open in a new window">Privacy Policy</a>.</p>

      {errorMessages.map( (error,index) => <div className="error-form" key={index}><ErrorOutline /><span>{error}</span></div>)}

      {/*accountErrorMessages.map( (error, index) => <div className="error-form" key={index}><Error /><span>{error}</span></div>)*/}
      <div className="account-success-overlay">{success}</div>
      <hr />
    <p>{subscriptionInfo}</p>
    <p>Any questions? Check our <a target="_blank" href="http://www.sanako.com/help/pronounce-live-faq/">FAQ</a>.</p>
    </div>
    </Card>
        );
  }


  renderSubscriptionForm = () => <StripeCheckout {...this.props} />;

  render() {
    const { singleregistration, subscriptions } = this.props;

    if (!subscriptions.hasFetchedPlan) {
      //return <span>Fetching plan...</span>;
    }

    return (
      <div key="registration">
        <h3 className="center">Use for free until the end of March 2018.</h3>
      <div className="account-creation">
          {this.renderAccountForm()}
        </div>
      </div>
    );
  }
}

export default SingleUserRegistrationAndroid;



// WEBPACK FOOTER //
// ./src/components/SingleUserRegistrationAndroid.js